export default "__VITE_ASSET__BcuvhSJ8__"